import { render, staticRenderFns } from "./weekly-orders.vue?vue&type=template&id=a3317d04"
import script from "./weekly-orders.vue?vue&type=script&lang=js"
export * from "./weekly-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports